import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-face-2",
  "use": "foquz-icon-rating-face-2-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol viewBox=\"0 0 11 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-face-2\"><path d=\"M10 10a6.36 6.36 0 00-2.054-1.47A6.085 6.085 0 005.514 8a6.079 6.079 0 00-2.44.492A6.358 6.358 0 001 9.93\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" /><circle cx=\"1.5\" cy=\"1.5\" r=\"1.5\" fill=\"#fff\" /><circle cx=\"9.5\" cy=\"1.5\" r=\"1.5\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol